import ar from "./ar.json";
import de from "./de.json";
import en from "./en.json";
import fr from "./fr.json";
import pl from "./pl.json";
import pt from "./pt.json";

export default { ar, de, en, fr, pl, pt };
